const PROD = import.meta.env.VITE_PROD_MODE;

type ApiRequestOptions = Omit<RequestInit, "body" | "headers"> & {
  body?: unknown;
  headers?: Record<string, string>;
};

type FetchApiOptions = Omit<RequestInit, "headers"> & {
  headers?: Record<string, string>;
};

export const getApiURL = (input: string): string => {
  if (import.meta.env.VITE_CLINICIANS_PLUS_QA === "true") {
    if (!import.meta.env.DEV) {
      throw new Error("Clinicians+ QA routing requires Vite development mode");
    }
    return "/api/v1" + input;
  }

  if (PROD === "true" || PROD === true)
    return "https://api.mimiathealth.com/api/v1" + input;
  else return "https://api-p77u.onrender.com/api/v1" + input;
};

export const fetchApi = async <T = unknown>(
  input: string,
  options: FetchApiOptions = {},
  token: string | null = null
): Promise<T> => {
  const headers = options.headers || {};
  const url = getApiURL(input);
  const completeOptions = {
    ...options,
    headers: {
      Accept: "application/json",
      Authorization: token ? "Bearer " + token : null,
      "Content-Type": "application/json",
      ...headers,
    },
  };
  const res = await fetch(url, completeOptions as RequestInit);
  const json = await res.json();
  return json as T;
};

export const getApi = <T = unknown>(
  input: string,
  options: ApiRequestOptions = {},
  token: string | null = null
) =>
  fetchApi<T>(
    input,
    {
      ...options,
      method: "GET",
      body: JSON.stringify(options.body),
    },
    token
  );

export const postApi = <T = unknown>(
  input: string,
  options: ApiRequestOptions = {},
  token: string | null = null
) =>
  fetchApi<T>(
    input,
    {
      ...options,
      method: "POST",
      body: JSON.stringify(options.body),
    },
    token
  );

export const patchApi = <T = unknown>(
  input: string,
  options: ApiRequestOptions = {},
  token: string | null = null
) =>
  fetchApi<T>(
    input,
    {
      ...options,
      method: "PATCH",
      body: JSON.stringify(options.body),
    },
    token
  );

export const deleteApi = <T = unknown>(
  input: string,
  options: ApiRequestOptions = {},
  token: string | null = null
) =>
  fetchApi<T>(
    input,
    {
      ...options,
      method: "DELETE",
      body: JSON.stringify(options.body),
    },
    token
  );

export const putApi = <T = unknown>(
  input: string,
  options: ApiRequestOptions = {},
  token: string | null = null
) =>
  fetchApi<T>(
    input,
    {
      ...options,
      method: "PUT",
      body: JSON.stringify(options.body),
    },
    token
  );
